var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Arrows / Alt Arrow Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24686 10.5568L12.5333 6.13646C12.8008 5.86064 12.6387 5.33334 12.2864 5.33334H3.71345C3.36118 5.33334 3.19905 5.86064 3.46652 6.13646L7.75298 10.5568C7.89508 10.7033 8.10476 10.7033 8.24686 10.5568Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdArrowDropDown);
export default __webpack_public_path__ + "static/media/MdArrowDropDown.2f68bfe391ef4436dda74c88ec628def.svg";
export { ForwardRef as ReactComponent };